import { useState } from 'react';
import dayjs from 'dayjs';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dialog, IconButton, InputAdornment, TextField } from '@mui/material';

export default function BirthDateField({
  label,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  disabled = false,
  locale,
  maxDate,
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TextField
        label={label}
        placeholder={placeholder}
        value={value ? dayjs(value).format('DD/MM/YYYY') : ''}
        variant="outlined"
        fullWidth
        error={error}
        helperText={helperText}
        disabled={disabled}
        onClick={() => {
          if (disabled) return;
          setOpen(true);
        }}
        slotProps={{
          input: {
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    if (disabled) return;
                    setOpen(true);
                  }}
                  edge="end"
                  disabled={disabled}
                >
                  <CalendarTodayIcon sx={{ color: 'text.secondary' }} />
                </IconButton>
              </InputAdornment>
            ),
          },
          inputLabel: { shrink: true },
        }}
      />
      <Dialog open={open} onClose={() => setOpen(false)}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <DateCalendar
            value={value}
            maxDate={maxDate}
            views={['year', 'month', 'day']}
            openTo="year"
            onChange={(newValue, selectionState) => {
              onChange(newValue);
              if (selectionState === 'finish') {
                setOpen(false);
              }
            }}
          />
        </LocalizationProvider>
      </Dialog>
    </>
  );
}
